import { Box, Avatar } from "@mui/material";

type ImgEstudianteProps = {
  foto: string;
};

export default function ImgEstudiante({ foto }: ImgEstudianteProps) {
  return (
    <Box
      sx={{
        width: "150px",
        height: "150px",
        marginTop: -9,
        borderRadius: 3,
        overflow: "hidden",
        boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
      }}
    >
      <Avatar
        sx={{ width: "100%", height: "100%" }}
        variant="square"
        src={`data:image/;base64, ${foto}`}
        alt=""
      />
    </Box>
  );
}
